export default "__VITE_ASSET__BnX99rTt__"